import { render } from "./OfferIPA.vue?vue&type=template&id=6c05de9a&scoped=true"
import script from "./OfferIPA.vue?vue&type=script&lang=js"
export * from "./OfferIPA.vue?vue&type=script&lang=js"

import "./OfferIPA.vue?vue&type=style&index=0&id=6c05de9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c05de9a"]])

export default __exports__